import React from 'react';
import { Cardapio } from 'modulos/cardapio/containers';

export const CardapioHome = () => {
  return <Cardapio visualizacao="cardapio" />;
};
